// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r9vSc {
    flex: 1;
    margin: 5px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    min-width: 45%;
    min-height: 150px;
    overflow: hidden;
    position: relative;
}

.hywtC {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.HyVrQ {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Side buttons */
.gpdt5 {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 53%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
}

.vnnTX {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 53%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
}

.Qd6QG {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: opacity 0.15s ease;
}

.NOhR5 {
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3), transparent);
}

.MyiES {
    width: 100%;
    height: 100%;
    background: linear-gradient(to left, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3), transparent);
}

.pzdqx {
    position: relative;
}

/* Health display */
.LNTnJ {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    pointer-events: none;
}

.ioHYc {
    font-family: 'BalooBhaijaan2', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 95px;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.9);
    padding-left: 5px;
    padding-right: 5px;
    margin-top: -20px;
}

/* Header container */
.Q8sl4 {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 100;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
}

/* Delta text */
.MLLAp {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -15px;
}

.fWKQp {
    font-family: 'BalooBhaijaan2', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 30px;
    font-weight: bold;
    padding-left: 5px;
    padding-right: 5px;
    color: rgba(255, 255, 255, 0.9);
}

/* Negative health mode button */
.Ntgjj {
    position: absolute;
    top: 6%;
    z-index: 950;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.Auc26 {
    background-color: rgba(0, 0, 0, 0.5);
    padding: 8px 16px;
    border-radius: 8px;
}

.lIEWI {
    color: white;
    opacity: 0.9;
    font-weight: bold;
    font-size: 14px;
}

/* Commander container */
.YJbXW {
    z-index: 20;
    position: absolute;
    bottom: 5px;
    background-color: rgba(0, 0, 0, 0.9);
    border-radius: 8px;
    width: 30%;
    height: 60px;
    padding: 4px;
    padding-left: 7px;
    padding-right: 7px;
}

.Dv4VH {
    flex: 1;
    width: 100%;
    height: 100%;
}

/* Dead overlay */
.U0iV2 {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    pointer-events: none;
}

/* Player name/settings */
.td2Bm {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 4px 6px;
    border-radius: 6px;
    z-index: 3;
    height: 36px;
    min-width: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.EkGpv {
    position: absolute;
    z-index: 3;
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
}

.aBVRX {
    font-size: 15px;
    font-weight: bold;
    color: white;
}

@media (min-width: 768px) {
    .ioHYc {
        font-size: 150px;
        margin-top: 0;
    }

    .Q8sl4 {
        top: 12%;
    }

    .fWKQp {
        font-size: 38px;
    }

    .Ntgjj {
        top: 10%;
    }

    .Auc26 {
        padding: 12px 16px;
        border-radius: 6px;
    }

    .lIEWI {
        font-size: 18px;
    }

    .YJbXW {
        bottom: 20px;
        height: 30%;
        padding: 5px 8px;
    }

    .pzdqx {
        width: 70px;
        height: 70px;
    }

    .td2Bm {
        padding: 5px 10px;
        border-radius: 5px;
        min-width: 120px;
        height: 44px;
    }

    .aBVRX {
        font-size: 18px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/playerCard/PlayerCard.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,QAAQ;IACR,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0FAA0F;AAC9F;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yFAAyF;AAC7F;;AAEA;IACI,kBAAkB;AACtB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,gGAAgG;IAChG,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gGAAgG;IAChG,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA,gCAAgC;AAChC;IACI,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA,wBAAwB;AACxB;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,qCAAqC;IACrC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,oBAAoB;AACxB;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI;QACI,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".card {\n    flex: 1;\n    margin: 5px;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    min-width: 45%;\n    min-height: 150px;\n    overflow: hidden;\n    position: relative;\n}\n\n.gradientBackground {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n.innerContainer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n/* Side buttons */\n.leftSide {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 53%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2;\n}\n\n.rightSide {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    width: 53%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2;\n}\n\n.sideOverlay {\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    transition: opacity 0.15s ease;\n}\n\n.leftGradient {\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3), transparent);\n}\n\n.rightGradient {\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(to left, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3), transparent);\n}\n\n.sideIcon {\n    position: relative;\n}\n\n/* Health display */\n.centerContainer {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2;\n    pointer-events: none;\n}\n\n.lifeText {\n    font-family: 'BalooBhaijaan2', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    font-size: 95px;\n    font-weight: bold;\n    color: rgba(255, 255, 255, 0.9);\n    padding-left: 5px;\n    padding-right: 5px;\n    margin-top: -20px;\n}\n\n/* Header container */\n.headerContainer {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    z-index: 100;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    pointer-events: none;\n}\n\n/* Delta text */\n.deltaContainer {\n    position: absolute;\n    left: 0;\n    right: 0;\n    z-index: 5;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: -15px;\n}\n\n.deltaText {\n    font-family: 'BalooBhaijaan2', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    font-size: 30px;\n    font-weight: bold;\n    padding-left: 5px;\n    padding-right: 5px;\n    color: rgba(255, 255, 255, 0.9);\n}\n\n/* Negative health mode button */\n.negativeHealthButtonContainer {\n    position: absolute;\n    top: 6%;\n    z-index: 950;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n}\n\n.negativeHealthButton {\n    background-color: rgba(0, 0, 0, 0.5);\n    padding: 8px 16px;\n    border-radius: 8px;\n}\n\n.negativeHealthButtonText {\n    color: white;\n    opacity: 0.9;\n    font-weight: bold;\n    font-size: 14px;\n}\n\n/* Commander container */\n.commandersContainer {\n    z-index: 20;\n    position: absolute;\n    bottom: 5px;\n    background-color: rgba(0, 0, 0, 0.9);\n    border-radius: 8px;\n    width: 30%;\n    height: 60px;\n    padding: 4px;\n    padding-left: 7px;\n    padding-right: 7px;\n}\n\n.commandersContainerButton {\n    flex: 1;\n    width: 100%;\n    height: 100%;\n}\n\n/* Dead overlay */\n.deadOverlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.75);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1;\n    pointer-events: none;\n}\n\n/* Player name/settings */\n.playerTextContainer {\n    position: absolute;\n    background-color: rgba(0, 0, 0, 0.5);\n    padding: 4px 6px;\n    border-radius: 6px;\n    z-index: 3;\n    height: 36px;\n    min-width: 90px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.cogContainer {\n    position: absolute;\n    z-index: 3;\n    width: 36px;\n    height: 36px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 5px;\n}\n\n.playerText {\n    font-size: 15px;\n    font-weight: bold;\n    color: white;\n}\n\n@media (min-width: 768px) {\n    .lifeText {\n        font-size: 150px;\n        margin-top: 0;\n    }\n\n    .headerContainer {\n        top: 12%;\n    }\n\n    .deltaText {\n        font-size: 38px;\n    }\n\n    .negativeHealthButtonContainer {\n        top: 10%;\n    }\n\n    .negativeHealthButton {\n        padding: 12px 16px;\n        border-radius: 6px;\n    }\n\n    .negativeHealthButtonText {\n        font-size: 18px;\n    }\n\n    .commandersContainer {\n        bottom: 20px;\n        height: 30%;\n        padding: 5px 8px;\n    }\n\n    .sideIcon {\n        width: 70px;\n        height: 70px;\n    }\n\n    .playerTextContainer {\n        padding: 5px 10px;\n        border-radius: 5px;\n        min-width: 120px;\n        height: 44px;\n    }\n\n    .playerText {\n        font-size: 18px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `r9vSc`,
	"gradientBackground": `hywtC`,
	"innerContainer": `HyVrQ`,
	"leftSide": `gpdt5`,
	"rightSide": `vnnTX`,
	"sideOverlay": `Qd6QG`,
	"leftGradient": `NOhR5`,
	"rightGradient": `MyiES`,
	"sideIcon": `pzdqx`,
	"centerContainer": `LNTnJ`,
	"lifeText": `ioHYc`,
	"headerContainer": `Q8sl4`,
	"deltaContainer": `MLLAp`,
	"deltaText": `fWKQp`,
	"negativeHealthButtonContainer": `Ntgjj`,
	"negativeHealthButton": `Auc26`,
	"negativeHealthButtonText": `lIEWI`,
	"commandersContainer": `YJbXW`,
	"commandersContainerButton": `Dv4VH`,
	"deadOverlay": `U0iV2`,
	"playerTextContainer": `td2Bm`,
	"cogContainer": `EkGpv`,
	"playerText": `aBVRX`
};
export default ___CSS_LOADER_EXPORT___;
